"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildStripeBillingCheckoutPayload = buildStripeBillingCheckoutPayload;
exports.buildStripeBillingCustomerResponse = buildStripeBillingCustomerResponse;
exports.buildStripeBillingCheckoutResponse = buildStripeBillingCheckoutResponse;
exports.buildStripeBillingPortalSessionResponse = buildStripeBillingPortalSessionResponse;
exports.buildStripeBillingSubscriptionSnapshotResponse = buildStripeBillingSubscriptionSnapshotResponse;
exports.buildStripeBillingEventResponse = buildStripeBillingEventResponse;
exports.buildStripeBillingInvoiceResponse = buildStripeBillingInvoiceResponse;
exports.buildStripeBillingPaymentIntentResponse = buildStripeBillingPaymentIntentResponse;
exports.buildStripeBillingCheckoutSessionEventResponse = buildStripeBillingCheckoutSessionEventResponse;
const Subscription_1 = require("./Subscription");
const StripeBillingContractsHelpers_1 = require("./StripeBillingContractsHelpers");
function normalizeNbSeats(value) {
    const seats = typeof value === "number" ? value : Number(value);
    if (!Number.isFinite(seats) || seats < 0) {
        throw new Error("Stripe checkout payload requires nb_seats >= 0");
    }
    return Math.trunc(seats);
}
function normalizeFrequency(value) {
    if (value === undefined || value === null || value === "") {
        return undefined;
    }
    if (value === Subscription_1.EPaymentFrequency.Monthly || value === Subscription_1.EPaymentFrequency.Yearly) {
        return value;
    }
    throw new Error("Stripe checkout payload has invalid frequency");
}
function normalizeCustomerString(value) {
    return typeof value === "string" ? value : "";
}
function normalizeOptionalString(value) {
    return typeof value === "string" ? value : undefined;
}
function normalizeOptionalNumber(value) {
    if (value === null)
        return null;
    return typeof value === "number" && Number.isFinite(value) ? value : undefined;
}
function normalizeOptionalInteger(value) {
    return typeof value === "number" && Number.isFinite(value) ? Math.trunc(value) : undefined;
}
function normalizeStripeExpandableId(value) {
    if (typeof value === "string")
        return value;
    if (typeof value === "object" && value !== null) {
        const id = value.id;
        if (typeof id === "string")
            return id;
    }
    return undefined;
}
function normalizeStripeEventData(value) {
    if (typeof value === "string")
        return value;
    if (typeof value === "object" && value !== null)
        return value;
    return {};
}
function buildStripeBillingCheckoutPayload(payload) {
    const normalizedFrequency = normalizeFrequency(payload.frequency);
    return {
        type: payload.type,
        nb_seats: normalizeNbSeats(payload.nb_seats),
        ...(normalizedFrequency ? { frequency: normalizedFrequency } : {}),
    };
}
function buildStripeBillingCustomerResponse(payload) {
    return {
        email: normalizeCustomerString(payload.email),
        name: normalizeCustomerString(payload.name),
    };
}
function buildStripeBillingCheckoutResponse(payload) {
    return {
        url: typeof payload.url === "string" ? payload.url : "",
    };
}
function buildStripeBillingPortalSessionResponse(payload) {
    const url = normalizeOptionalString(payload.url);
    const cancelAt = normalizeOptionalNumber(payload.cancel_at);
    return {
        ...(url !== undefined ? { url } : {}),
        ...(cancelAt !== undefined ? { cancel_at: cancelAt } : {}),
    };
}
function buildStripeBillingSubscriptionSnapshotResponse(payload) {
    const status = normalizeOptionalString(payload.status);
    const cancelAt = normalizeOptionalNumber(payload.cancel_at);
    const items = (0, StripeBillingContractsHelpers_1.normalizeSnapshotItems)(payload.items);
    return {
        ...(status !== undefined ? { status } : {}),
        ...(cancelAt !== undefined ? { cancel_at: cancelAt } : {}),
        ...(items !== undefined ? { items } : {}),
    };
}
function buildStripeBillingEventResponse(payload) {
    return {
        id: typeof payload.id === "string" ? payload.id : "",
        type: typeof payload.type === "string" ? payload.type : "",
        created: typeof payload.created === "number" && Number.isFinite(payload.created) ? payload.created : 0,
        data: normalizeStripeEventData(payload.data),
    };
}
function buildStripeBillingInvoiceResponse(payload) {
    var _a;
    const status = normalizeOptionalString(payload.status);
    const billingReason = normalizeOptionalString(payload.billing_reason);
    const subscriptionId = normalizeStripeExpandableId(payload.subscription);
    const paymentIntentId = normalizeStripeExpandableId(payload.payment_intent);
    return {
        id: typeof payload.id === "string" ? payload.id : "",
        created: (_a = normalizeOptionalInteger(payload.created)) !== null && _a !== void 0 ? _a : 0,
        ...(status !== undefined ? { status } : {}),
        ...(billingReason !== undefined ? { billing_reason: billingReason } : {}),
        ...(subscriptionId !== undefined ? { subscription_id: subscriptionId } : {}),
        ...(paymentIntentId !== undefined ? { payment_intent_id: paymentIntentId } : {}),
    };
}
function buildStripeBillingPaymentIntentResponse(payload) {
    var _a;
    const status = normalizeOptionalString(payload.status);
    const amount = normalizeOptionalInteger(payload.amount);
    const currency = normalizeOptionalString(payload.currency);
    return {
        id: typeof payload.id === "string" ? payload.id : "",
        created: (_a = normalizeOptionalInteger(payload.created)) !== null && _a !== void 0 ? _a : 0,
        ...(status !== undefined ? { status } : {}),
        ...(amount !== undefined ? { amount } : {}),
        ...(currency !== undefined ? { currency } : {}),
    };
}
function buildStripeBillingCheckoutSessionEventResponse(payload) {
    return (0, StripeBillingContractsHelpers_1.buildCheckoutSessionEventResponse)(payload);
}
